import styled from 'styled-components';
import { colors } from 'globalStyles';

// Mirrors PlanSelectionModal's ContentWrapper — the two prompts appear in the
// same places and should not be a different shape from each other. The heading
// is coloured RED like its sibling: this is a stop, not an announcement.
export const ContentWrapper = styled.div`
  padding-top: 34px;
  width: 300px;

  > h1 {
    color: ${colors.RED};
    font-size: 36px;
    line-height: 44px;
    margin: 0;
    font-family: poppins, sans-serif;
  }
`;
